<template>
    <div id="contactUsCom" class="contactUsCom">
        <el-dialog
            title="联系方式"
            :visible.sync="tokenDialog"
            :close-on-click-modal="false"
            width="30%"
            :before-close="() => close()"
        >
            <div v-if="tips !== ''" style="font-weight: 700; font-size: 17px; color: red; margin: 10px 3px;">
                {{ tips }}
            </div>
            <div class="contactUs-content">
                <div class="img-wrapper">
                    <img class="imgone" :src="`${$baseUrl}dataMock/devCenter/account-contactUs.png`" />
                </div>
                <div class="contactUs-detail">
                    <span class="content-list">189-1614-5929（微信同号） 吴经理</span>
                    <span class="content-list">Email：cloud@pkpm.com.cn</span>
                </div>
            </div>
            <div style="font-weight: 700; margin: 10px 3px;">联系内容</div>
            <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model.trim="textarea"
                maxlength="170"
                show-word-limit
                rows="5"
                resize="none"
            >
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="sendMessage">联系我们</el-button>
                <el-button size="mini" @click="close">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'contactUsCom',
    components: {},
    data() {
        return {
            tokenDialog: false,
            tokenData: '',
            textarea: '',
            tips: '',
        };
    },
    mounted() {},
    methods: {
        Open(tips) {
            if (tips) {
                this.tips = tips;
            }
            this.tokenDialog = true; //  打开模态框
        },
        close() {
            this.textarea = '';
            this.tokenDialog = false; //  关闭模态框
        },
        sendMessage() {
            this.$emit('send-message', this.textarea);
        },
    },
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
#contactUsCom >>> .el-dialog__body
  padding-top 5px
  .contactUs-content
    display flex
    flex-direction flex-start
    .img-wrapper
      display flex
      align-items center
      justify-content center
      padding 20px
      width 30%
      img
        max-width 50px
        max-height 50px
        width 100%
        height 100%
    .contactUs-detail
      dom_center()
      align-items flex-start
      flex-direction column
      .content-list
        margin-top 20px
        font-size 16px
        font-weight bold
        color $font-itemTitle
        user-select text
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/contactUsCom.vue